import { Stats } from '../sim/types'
import { World } from '../sim/world'

// Challenge modifiers — opt-in run modifiers selectable from the menu. applyWorld
// runs at run start (flags/curse/difficulty); applyStats runs inside recompute.
export interface ChallengeDef {
  id: string
  name: string // EN; IT via i18n tName('challenge', id, name)
  desc: string // EN; IT via i18n tBlurb('challenge', id, desc)
  icon: string
  applyWorld?: (w: World) => void
  applyStats?: (s: Stats) => void
}

export const CHALLENGE_LIST: ChallengeDef[] = [
  {
    id: 'double_bosses',
    name: 'Boss Rush',
    desc: 'Bosses appear twice as often. Hope you packed firepower.',
    icon: '👹',
    applyWorld: (w) => {
      w.bossRateMul = 0.5
      w.nextBossAt = 75
    },
  },
  {
    id: 'glass_cannon',
    name: 'Glass Cannon',
    desc: 'Massive damage, but you have a fraction of the HP.',
    icon: '💥',
    applyStats: (s) => {
      s.maxHp *= 0.4
      s.damage += 1.0
    },
  },
  {
    id: 'swarm',
    name: 'Endless Swarm',
    desc: 'The horde is enormous from the very start.',
    icon: '🐜',
    applyWorld: (w) => {
      w.difficulty *= 1.7
    },
  },
  {
    id: 'cursed_start',
    name: 'Cursed Start',
    desc: 'Begin with +3 curse — more aliens, more bosses, more loot.',
    icon: '☠️',
    applyWorld: (w) => {
      w.curse += 3
    },
  },
  {
    id: 'iron_man',
    name: 'Iron Man',
    desc: 'No healing of any kind. Every hit counts.',
    icon: '🛡️',
    applyWorld: (w) => {
      w.noHeal = true
    },
  },
  {
    id: 'speed_demon',
    name: 'Speed Demon',
    desc: 'Lightning-fast hero — but the swarm is faster and denser too.',
    icon: '⚡',
    applyWorld: (w) => {
      w.difficulty *= 1.3
      w.enemySpeedMul = 1.25 // honor the "faster swarm" promise (difficulty alone only scales density + HP/damage, not move speed)
    },
    applyStats: (s) => {
      s.moveSpeed *= 1.4
      s.attackSpeed += 0.3
    },
  },
]

export const CHALLENGES: Record<string, ChallengeDef> = {}
for (const c of CHALLENGE_LIST) CHALLENGES[c.id] = c
